import { useState, useEffect} from "react"


const useFetch = (url) => {
    const [data, setData] = useState(null);
/* setter with a log
    const setData = (newData) => {
        data = newData;
        console.log(data);
    }

    useEffect(() => {

    const abortCtrl   = new AbortController();

    const fetchData = async () => {
        try {
            const response = await fetch(url,{signal: abortCtrl.signal});
            const json = await response.json();
            setData(json);
            console.log("fetch done");
                
        } catch (error) {
            if (error.name === 'AbortError'){
                console.log("aborted", error);
            }
            else {
            console.log("error", error);
            }
        }
    }

    fetchData();

    return () => abortCtrl.abort();

    }, [url]);
*/

    useEffect(() => {

        const abortCtrl   = new AbortController();
        const fetchData = async () => {
            try {   
                fetch(url,{signal: abortCtrl.signal})
                    .then(response  => {
                        if (!response.ok) {
                            throw Error("Resource Not Found");
                        }
                        return response.json()
                    })
                    .then(jsonData => {
                        setData(jsonData);
                        console.log("-fetch done");
                    })
            } catch (error) {
                if (error.name === 'AbortError'){
                console.log("-aborted", error);
                }
                else {
                    console.log("-error", error);
                }
            }
        }

        fetchData();

        return () => abortCtrl.abort();
        
    }, []);

    return {data}
}

export default useFetch;